import { isoToCountryName } from "@/common/helpers/iso-display-name";
import { Badge, BadgeColorVariant, BadgeVariant } from "@/components/ui/badge";
import { EmptyValue } from "@/components/ui/empty-value";

interface AddressLike {
  recipientName?: string | null;
  company?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  houseExtension?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country_code?: string | null;
}

export function AddressBlock({ typeLabel, address }: { typeLabel?: string; address: AddressLike }) {
  const streetLine = [address.street, address.houseNumber, address.houseExtension].filter(Boolean).join(" ").trim();
  const cityLine = [address.postalCode, address.city].filter(Boolean).join(" ").trim();
  const countryName = isoToCountryName(address.country_code);

  return (
    <div className="flex flex-col gap-2">
      {typeLabel && (
        <div>
          <Badge colorVariant={BadgeColorVariant.Primary} variant={BadgeVariant.Outlined}>
            {typeLabel}
          </Badge>
        </div>
      )}
      <div className="text-sm leading-relaxed">
        {address.recipientName && <div>{address.recipientName}</div>}
        {address.company && <div>{address.company}</div>}
        {streetLine && <div>{streetLine}</div>}
        {cityLine && <div>{cityLine}</div>}
        {countryName && <div className="text-muted-foreground">{countryName}</div>}
        {!address.recipientName && !address.company && !streetLine && !cityLine && !countryName && <EmptyValue />}
      </div>
    </div>
  );
}
